import HeroHeader from "./HeroHeader";

// export default function MiniHeader() {
//   return (
//     // <div className="p-2 bg-white">
//     <div
//     className="p-2 bg-white rounded-xl shadow-lg"
//     style={{ WebkitAppRegion: "drag" }}
//   >
//       <DashboardHeader />
//     </div>
//   );
// }

export default function MiniHeader() {
    return (
        <div
        className="p-4 bg-gray-400 rounded-t-xl cursor-move"
        style={{ WebkitAppRegion: "drag" }}
      >
      {/* <div className="rounded-xl shadow-lg bg-white"> */}
        
        {/* Drag area */}
        {/* <div
          className="p-2 bg-gray-400 rounded-t-xl cursor-move"
          style={{ WebkitAppRegion: "drag" }}
        >
           */}
        {/* </div> */}
  
        {/* Clickable area */}
        <div
          className="p-2"
          style={{ WebkitAppRegion: "no-drag" }}
        >
          <HeroHeader />
        </div>
  
      </div>
    //   </div>
    );
  }
  








    // "scripts": {
  //   "start": "react-scripts start",
  //   "electron": "electron .",
  //   "build": "react-scripts build",
  //   "test": "react-scripts test",
  //   "eject": "react-scripts eject"

    
  // },